/* =========================

  this page index

============================ */
import {createGlobalStyle} from "styled-components";
import { Helmet } from "react-helmet";
import {base} from "./Styled/add_base";
import { BrowserRouter, Routes,Route,Navigate } from 'react-router-dom';

import Diagnoise from "./Page/Top/index";
import Results from "./Page/result/index";
import Result from "./Page/result/id";


/* -------------------------

  component

---------------------------- */
function App() {
  return (
    <>
    <Helmet>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      <link href="https://fonts.googleapis.com/css2?family=Kiwi+Maru:wght@300;400;500&display=swap" rel="stylesheet" />
    </Helmet>
    <GlobalStyle/>

    <div className="project">

    <BrowserRouter basename="/shindan">
      <Routes>
        <Route path="/" element={<Diagnoise />} />
        <Route path="/result" element={<Results />}>
          <Route path=":childId" element={<Result />} />
        </Route>
        <Route path="*" element={<Navigate to="/" />}/>
      </Routes>
    </BrowserRouter>

    </div>
    </>
  );
}

export default App;

/* -------------------------

  styled

---------------------------- */
const GlobalStyle = createGlobalStyle`
  .project{
    ${base}
  }
`
